module.exports = __webpack_public_path__ + "b4f8652af835ea64fc53aabfb4b6beaf.fbx";